import { render, staticRenderFns } from "./JobSeekerStats.vue?vue&type=template&id=189a0646&scoped=true&"
import script from "./JobSeekerStats.vue?vue&type=script&lang=js&"
export * from "./JobSeekerStats.vue?vue&type=script&lang=js&"
import style0 from "./JobSeekerStats.vue?vue&type=style&index=0&id=189a0646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a0646",
  null
  
)

export default component.exports